<template>
    <div class="dialogBox">
        <el-dialog :visible.sync="dialogVisible" width="583">
            <div class="dialogBg">
                <div class="dialogContentBox">
                    <div class="title">提示</div>
                    <div class="contentText">
                        当前生成视频需要排队等待，之前还有<span class="num">{{ waitNum }}</span>个视频等待生成，是否排队等待？
                    </div>
                    <div class="subContent">排队等待期间，请勿关闭浏览器和后台，否则排队将会取消。 若不排队等待，请先保存草稿，在低峰时段生成。</div>
                    <div class="btns">
                        <el-button type="primary" plain @click="saveDraft">仅存为草稿</el-button>
                        <el-button type="primary" @click="saveVideo">{{ waitNum === 0 ? '生成视频' : '排队等待' }}</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { queryVideoWaitNum } from "@/assets/api/aiProduct";
export default {
  data() {
    return {
      waitNum: 0,
      loading: false,
      dialogVisible: false,
    };
  },
  methods: {
    saveDraft() {
      this.$emit("draft");
      this.dialogVisible = false;
    },
    saveVideo() {
      this.$emit("save");
      this.dialogVisible = false;
    },
    queryNum() {
      this.loading = true;
      queryVideoWaitNum()
        .then((res) => {
          if (res.code === "200") {
            this.waitNum = res.data.waitNum;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
     open() {
        // 这里要调一个排队任务数量的接口
        this.queryNum()
        this.dialogVisible = true
    }
  },
};

</script>

<style scoped lang="scss">
.dialogBg {
    // https://image2.soole.com.cn/slb-picture2025051318194877320.jpg
    background-image: url(https://image2.soole.com.cn/slb-picture2025051318195312551.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    width: 583px;
    height: 443px;
}

.dialogBox ::v-deep .el-dialog__body {
    padding: 0 !important;
}

.dialogBox ::v-deep .el-dialog__header {
    padding: 0 !important;
}

.dialogContentBox {
    display: flex;
    flex-direction: column;
    position: relative;
    top: 188px;

    .title {
        font-weight: 600;
        font-size: 20px;
        margin-bottom: 30px;
        text-align: center;
    }

    .contentText {
        font-size: 16px;
        margin-bottom: 16px;
        color: rgba(31, 33, 38, 1);
        text-align: center;

        .num {
            color: rgba(246, 89, 54, 1);
        }
    }

    .subContent {
        margin: auto;
        width: 450px;
        font-size: 16px;
        color: rgba(172, 178, 195, 1);
        text-align: center;
        margin-bottom: 48px;
    }

    .btns {
        display: flex;
        gap: 26px;
        justify-content: center;
    }
}
</style>